<template>
    <div>
        <v-container fluid class="d-print-none">
            <v-row no-gutters>
                <v-col :cols="8">
                    <h1 class="headline font-weight-light mb-3">STOCK</h1>
                </v-col>
                <v-col :cols="4" class="text-right">
                    <v-text-field
                        v-model="form_search_singlepart"
                        label="Search Singlepart / Enter"
                        single-line
                        solo
                        rounded
                        dense
                        @keyup.enter="func_search_sg()"
                    ></v-text-field>
                </v-col>
            </v-row>

            <v-card>
                <v-card-title>
                    <!-- || emp_id == 'P17-017' -->
                    <v-row>
                        <v-col
                            cols="6"
                            sm="4"
                            md="2"
                            v-if="
                                team_name === 'INVENTORY' || emp_id == 'P17-017'
                            "
                        >
                            <v-autocomplete
                                :items="branch"
                                item-text="branch_name"
                                item-value="branch_id"
                                v-model="form.branch_id"
                                menu-props="auto"
                                label="Branch"
                                hide-details
                                ref="branchs_select"
                                @change="searchProject()"
                            ></v-autocomplete>
                        </v-col>
                        <v-col
                            cols="6"
                            sm="4"
                            md="2"
                            v-if="team_name !== 'ODM' && emp_id != 'P17-017'"
                        >
                            <v-autocomplete
                                :items="projects"
                                item-text="project_name"
                                item-value="project_id"
                                v-model="form.project_id"
                                menu-props="auto"
                                label="Project"
                                hide-details
                                ref="project_select"
                                @change="searchProject()"
                            ></v-autocomplete>
                        </v-col>
                        <v-col
                            cols="6"
                            sm="4"
                            md="2"
                            v-if="team_name === 'INVENTORY'"
                        >
                            <v-autocomplete
                                :items="categories"
                                item-text="category_name"
                                item-value="category_id"
                                v-model="form.category_id"
                                menu-props="auto"
                                label="Category"
                                hide-details
                                @change="searchProject()"
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="6" sm="4" md="3" v-if="emp_id != 'P17-017'"
                            ><v-text-field
                                v-model="form.search"
                                append-icon="mdi-magnify"
                                label="Search"
                                @keyup="searchProject($event.target.value)"
                            ></v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>

                        <v-col cols="12" sm="2" md="3" class="text-right mt-5">
                            <v-btn
                                x-small
                                fab
                                class="mr-1"
                                @click="reset()"
                                v-if="
                                    form.branch_id != '' ||
                                        form.project_id != '' ||
                                        form.category_id != '' ||
                                        form.search != '' ||
                                        form.category_id != ''
                                "
                            >
                                <v-icon>mdi-rotate-left</v-icon></v-btn
                            >
                            <v-btn
                                v-if="
                                    team_name === 'INVENTORY' ||
                                        (team_name === 'ASRC' &&
                                            emp_id != 'P17-017')
                                "
                                color="primary"
                                dark
                                :to="'/Inventory/Stock-In/' + current_page"
                                small
                                rounded
                            >
                                <v-icon small class="mr-1">mdi-plus</v-icon>
                                Stock in new part
                            </v-btn></v-col
                        >
                    </v-row>
                </v-card-title>

                <v-simple-table class="table-inv">
                    <template v-slot:default>
                        <thead>
                            <tr class="col-tr-1">
                                <th class="text-center">Project</th>
                                <!-- <th class="text-center">Supplier</th> -->
                                <th class="text-center">Part Description</th>
                                <th class="text-center">Part Type</th>
                                <th class="text-center">Qty</th>
                                <th class="text-center">More</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="item in data_stock.data"
                                :key="item.part_id"
                            >
                                <td>{{ item.project_name }}</td>
                                <!-- <td>{{ item.supplier_name }}</td> -->
                                <td class="pa-2">
                                    <div
                                        v-if="item.part_description"
                                        class="font-weight-medium"
                                    >
                                        <span
                                            v-if="
                                                item.part_description.length <
                                                    50
                                            "
                                        >
                                            {{ item.part_description }}
                                        </span>
                                        <span v-else>
                                            {{
                                                item.part_description.substring(
                                                    0,
                                                    50
                                                ) + "..."
                                            }}
                                        </span>
                                    </div>

                                    <span class="font-weight-light caption">{{
                                        item.part_name
                                    }}</span>
                                    <v-chip
                                        dense
                                        x-small
                                        class="ml-2"
                                        v-if="item.category_name"
                                    >
                                        {{ item.category_name }}
                                    </v-chip>
                                </td>
                                <td class="text-center">
                                    {{ item.part_type }}
                                </td>
                                <td class="text-center">
                                    <v-badge
                                        bordered
                                        color="success"
                                        :icon="item.onhand"
                                        overlap
                                        class="mr-4"
                                    >
                                        <v-btn
                                            class="white--text mr-1 ml-1"
                                            color="success"
                                            depressed
                                            x-small
                                            @click="
                                                detail('onhand', item.part_id)
                                            "
                                        >
                                            ONHAND
                                        </v-btn>
                                    </v-badge>
                                    <v-badge
                                        bordered
                                        color="warning"
                                        :icon="item.hub"
                                        overlap
                                        class="mr-4"
                                        v-if="item.hub > 0"
                                    >
                                        <v-btn
                                            class="white--text mr-1 ml-1"
                                            color="warning"
                                            depressed
                                            x-small
                                            @click="detail('hub', item.part_id)"
                                        >
                                            {{
                                                team_name == "SVC" ||
                                                team_name == "ONSITE" ||
                                                team_name == "SUPPORTUC"
                                                    ? "ENGINEER"
                                                    : "HUB"
                                            }}
                                        </v-btn>
                                    </v-badge>

                                    <v-badge
                                        bordered
                                        color="error"
                                        :icon="item.loan"
                                        overlap
                                        class="mr-4"
                                        v-if="item.loan > 0"
                                    >
                                        <v-btn
                                            class="white--text mr-1"
                                            color="error"
                                            depressed
                                            x-small
                                            @click="
                                                detail('loan', item.part_id)
                                            "
                                        >
                                            LOAN
                                        </v-btn>
                                    </v-badge>

                                    <v-badge
                                        bordered
                                        color="deep-purple lighten-1"
                                        :icon="item.defective"
                                        v-if="item.defective > 0"
                                        overlap
                                    >
                                        <v-btn
                                            class="white--text mr-1"
                                            color="deep-purple lighten-1"
                                            depressed
                                            x-small
                                            @click="
                                                detail(
                                                    'defective',
                                                    item.part_id
                                                )
                                            "
                                        >
                                            DEFECTIVE
                                        </v-btn>
                                    </v-badge>
                                </td>
                                <td class="text-center">
                                    <v-speed-dial
                                        :direction="direction"
                                        :transition="transition"
                                    >
                                        <template v-slot:activator>
                                            <v-btn
                                                color="cyan darken-1"
                                                dark
                                                fab
                                                x-small
                                            >
                                                <!-- <v-icon>mdi-close</!-->
                                                <v-icon
                                                    >mdi-dots-horizontal</v-icon
                                                >
                                            </v-btn>
                                        </template>

                                        <v-tooltip
                                            top
                                            v-if="
                                                team_name === 'INVENTORY' ||
                                                    team_name === 'ODM'
                                            "
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    color="success"
                                                    fab
                                                    small
                                                    v-on="on"
                                                    class="mr-2"
                                                    @click="add(item.part_id)"
                                                >
                                                    <v-icon small
                                                        >mdi-plus</v-icon
                                                    >
                                                </v-btn>
                                            </template>
                                            <span>Stock In Part</span>
                                        </v-tooltip>

                                        <v-tooltip
                                            top
                                            v-if="team_name === 'INVENTORY'"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    color="info"
                                                    fab
                                                    small
                                                    v-on="on"
                                                    @click="edit(item.part_id)"
                                                >
                                                    <v-icon small
                                                        >mdi-pencil</v-icon
                                                    >
                                                </v-btn>
                                            </template>
                                            <span>Edit</span>
                                        </v-tooltip>

                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    color=""
                                                    to=""
                                                    fab
                                                    small
                                                    class="mr-2"
                                                    v-on="on"
                                                    @click="
                                                        gen_barcode(
                                                            item.part_id
                                                        )
                                                    "
                                                >
                                                    <v-icon small
                                                        >mdi-barcode-scan</v-icon
                                                    >
                                                </v-btn>
                                            </template>
                                            <span>Gen Barcode</span>
                                        </v-tooltip>
                                    </v-speed-dial>
                                </td>
                            </tr>
                            <br />
                        </tbody>
                    </template>
                </v-simple-table>

                <div class="text-center pb-5 pt-4">
                    <div>
                        <v-btn
                            class="mx-2"
                            fab
                            small
                            @click="back()"
                            :disabled="page_count == 1"
                        >
                            <v-icon dark>mdi-chevron-left</v-icon>
                        </v-btn>

                        <v-btn
                            class="mx-2"
                            fab
                            small
                            :color="btn_color(n)"
                            v-for="n in page_count"
                            :key="n"
                            @click="get_stock_page(page_num_show(n))"
                        >
                            {{ page_num_show(n) }}
                        </v-btn>

                        <v-btn class="mx-2" fab small @click="next()">
                            <v-icon dark>mdi-chevron-right</v-icon>
                        </v-btn>
                    </div>
                </div>
            </v-card>
        </v-container>
        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Barcode -->
        <!-- <CompBarcode
            @page_barcode="gen_barcode()"
            :dialog="dialog"
            :part="part"
        /> -->
        <!-- End Barcode -->
    </div>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import { mapState, mapMutations } from "vuex"
import CompBarcode from "./components/Barcode"
import Search from "./components/Search"

const url_barcode = `${process.env.VUE_APP_ROOT_API}/api/getbarcode/`
const url_project = `${process.env.VUE_APP_ROOT_API}/api/project-has-stock/`

export default {
    created() {
        this.searchProject = _.debounce(this.searchProject, 300)
    },
    components: {
        CompBarcode: CompBarcode,
        Search,
    },
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        // this.get_stock()
        if (this.snackbar === true) {
            setTimeout(() => {
                this.mutatesnackbar()
            }, 2000)
        }
        this.chk_query()
        this.get_emp_id()
        // console.log(this.$route.query.q)
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        async get_stock() {
            this.mutateIsLoading()
            this.current_page = this.$route.params.pages

            if (this.current_page === undefined) {
                this.current_page = 1
            }
            let url =
                `${process.env.VUE_APP_ROOT_API}/api/stock?page=` +
                this.current_page
            await axios.get(url, this.tk).then((response) => {
                this.mutateIsLoading()
                this.data_stock = response.data
                this.page_total = response.data.last_page
                this.page_total < 7
                    ? (this.page_count = this.page_total)
                    : (this.page_count = 7)
            })

            this.get_search()
        },
        async get_search() {
            let data_stock_has = await axios.get(url_project, this.tk)
            this.projects = data_stock_has.data.projects
            this.branch = data_stock_has.data.branchs
            this.team_name = localStorage.team_name
            this.categories = data_stock_has.data.categories
        },
        async back() {
            let url = this.data_stock.prev_page_url
            let { data } = await axios.get(url)
            this.data_stock = data
        },
        async next() {
            let url = this.data_stock.next_page_url
            let { data } = await axios.get(url)
            this.data_stock = data
        },
        async get_stock_page(num) {
            this.current_page = num

            if (num != "...") {
                let url =
                    `${process.env.VUE_APP_ROOT_API}/api/stock?page=` +
                    num +
                    "&project_id=" +
                    this.form.project_id +
                    "&branch_id=" +
                    this.form.branch_id +
                    "&category_id=" +
                    this.form.category_id
                await axios
                    .get(url, this.tk)
                    .then((response) => {
                        this.data_stock = response.data
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        btn_color(n) {
            if (this.page_count == 7) {
                if (this.data_stock.current_page <= 4) {
                    return this.data_stock.current_page === n ? "primary" : ""
                } else if (
                    this.data_stock.current_page == this.data_stock.last_page
                ) {
                    return n === 7 ? "primary" : ""
                } else if (
                    this.data_stock.current_page ==
                    this.data_stock.last_page - 1
                ) {
                    return n === 6 ? "primary" : ""
                } else if (
                    this.data_stock.current_page ==
                    this.data_stock.last_page - 2
                ) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.data_stock.current_page === n ? "primary" : ""
            }
        },
        page_num_show(n) {
            let page = n
            if (this.page_count == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.data_stock.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_stock.last_page - 1
                } else if (
                    this.data_stock.current_page == this.data_stock.last_page
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_stock.last_page - 3
                    chk5 = this.data_stock.last_page - 2
                    chk6 = this.data_stock.last_page - 1
                } else if (this.data_stock.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_stock.last_page - 1
                } else if (
                    this.data_stock.current_page ==
                    this.data_stock.last_page - 1
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_stock.last_page - 3
                    chk5 = this.data_stock.last_page - 2
                    chk6 = this.data_stock.last_page - 1
                } else if (this.data_stock.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_stock.last_page - 1
                } else if (
                    this.data_stock.current_page ==
                    this.data_stock.last_page - 2
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_stock.last_page - 3
                    chk5 = this.data_stock.last_page - 2
                    chk6 = this.data_stock.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.data_stock.current_page - 1
                    chk4 = this.data_stock.current_page
                    chk5 = this.data_stock.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.data_stock.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }
            return page
        },
        edit(part_id) {
            let url = "/Inventory/Stock-In/" + this.current_page + "/" + part_id
            this.$router.push({
                path: url,
                query: { q: this.form },
                // props: qq,
            })
        },
        detail(type, part_id) {
            let url =
                "/Inventory/Stock-Detail/" +
                type +
                "/" +
                this.current_page +
                "/" +
                part_id +
                "/" +
                this.form.branch_id

            // this.$router.push(url, this.tk)
            this.$router.push(
                {
                    path: url,
                    query: { q: this.form },
                    // props: qq,
                },
                this.tk
            )
        },
        add(part_id) {
            let url =
                "/Inventory/Stock-In/Part/" + this.current_page + "/" + part_id
            this.$router.push({
                path: url,
                query: { q: this.form },
                // props: qq,
            })
        },
        async gen_barcode(part_id) {
            // if (this.dialog === false) {
            //     let { data } = await axios.get(url_barcode + part_id)
            //     this.part = data[0]
            // }
            // this.dialog = this.dialog === false ? true : false
            let url =
                "/Inventory/Stock-In/Barcode/" +
                this.current_page +
                "/" +
                part_id
            this.$router.push({
                path: url,
                query: { q: this.form },
            })
        },
        async searchProject(value) {
            this.dialog_loading = true
            let url = `${process.env.VUE_APP_ROOT_API}/api/stock?project_id=`
            let { data } = await axios.get(
                url +
                    this.form.project_id +
                    "&value=" +
                    value +
                    "&branch_id=" +
                    this.form.branch_id +
                    "&category_id=" +
                    this.form.category_id,
                this.tk
            )
            this.data_stock = data
            this.page_total = data.last_page
            this.page_total < 7
                ? (this.page_count = this.page_total)
                : (this.page_count = 7)
            this.dialog_loading = false
            // let project = await axios.get(url_project)
            // this.projects = project.data
        },
        reset() {
            this.form.project_id = ""
            this.form.category_id = ""
            this.form.search = ""
            this.form.branch_id = ""
            this.get_stock()
        },
        chk_query() {
            if (
                _.isEmpty(this.$route.query) == false &&
                (this.$route.query.q.branch_id != "" ||
                    this.$route.query.q.category_id != "" ||
                    this.$route.query.q.project_id != "" ||
                    this.$route.query.q.search != "")
            ) {
                this.form.branch_id = this.$route.query.q.branch_id
                this.form.category_id = this.$route.query.q.category_id
                this.form.project_id = this.$route.query.q.project_id
                this.form.search = this.$route.query.q.search
                this.searchProject(this.form.search)
                this.get_search()
            } else {
                this.get_stock()
            }
        },
        async func_search_sg() {
            let routeData = this.$router.resolve({
                path: "/Search-Parts",
                query: { q: this.form_search_singlepart },
            })
            window.open(routeData.href, "_blank")
        },
        async get_emp_id() {
            await axios
                .get(
                    `${process.env.VUE_APP_ROOT_API}/api/account-detail`,
                    this.tk
                )
                .then((response) => {
                    // console.log(response)
                    this.emp_id = response.data.emp_id
                })
        },
    },
    data() {
        return {
            emp_id: "",
            data_stock: [],
            projects: [],
            branch: [],
            categories: [],
            page: 1,
            page_total: 0,
            page_count: 0,
            chk_num_page: 0,
            search: "",
            current_page: 0,
            text: "Success, Your work has been saved",
            direction: "left",
            transition: "slide-y-reverse-transition",
            dialog: false,
            part: [],
            form: {
                project_id: "",
                search: "",
                branch_id: "",
                category_id: "",
            },
            team_name: localStorage.team_name,
            tk: "",
            form_search_singlepart: "",
            dialog_loading: false,
        }
    },
}
</script>
